import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({});

// Combine tailwind classes without conflicts.
// Usually classes appearing later in the arguments will override earlier ones.
// Occasionally it may be necessary to use `!` to force a class if not working as expected.

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
